<template>
  <div class="exploded" data-anim="explode">
    <canvas class="exploded__sprite"/>
  </div>
</template>

<script>
import loop from '@/scripts/loop';
import eventBus from '@/scripts/event-bus';

export default {
  name: 'ExplodedImage',

  data() {
    return {
      canvas: null,
      image: null,
      ctx: null,
      sprite: null,

      isLooping: false,
      numberOfFrames: 0,
      frameIndex: 0,
    };
  },

  mounted() {
    this.inizializeSprite();
    eventBus.$on('explode!', () => {
      this.isLooping = true;
    });
  },

  methods: {
    inizializeSprite() {
      // Get canvas
      this.canvas = this.$el.querySelector('.exploded__sprite');

      this.ctx = this.canvas.getContext('2d');

      this.sprite = new Image();
      this.sprite.src = '/static/images/tech-features/sprite.png';

      this.image = new Image();
      this.image.src = '/static/images/tech-features/sprite_single.png';

      this.image.onload = () => {
        this.setDim();
        loop.add(() => this.render(), 'sprite-animation', true);
      };
    },

    setDim() {
      this.col = 8;
      this.line = 7;

      const w = this.$el.getBoundingClientRect().width;
      const h = (this.$el.getBoundingClientRect().width * this.image.height) / this.image.width;

      this.canvas.width = w;
      this.canvas.height = h;

      this.numberOfFrames = this.col * this.line;

      this.frameWidth = w;
      this.frameHeight = h;
    },

    calcPosition() {
      // If the current frame index is in range
      this.frameIndex = !this.isLooping ? 0 : this.frameIndex + 1;

      this.sx = Math.floor(this.frameIndex % this.col) * this.image.width;
      this.sy = Math.floor(this.frameIndex / this.col) * this.image.height;
    },

    render() {
      this.calcPosition();
      // Clear the canvas
      this.ctx.clearRect(
        0,
        0,
        this.canvas.width,
        this.canvas.height,
      );

      this.ctx.drawImage(
        this.sprite,
        this.sx,
        this.sy,
        this.image.width,
        this.image.height,
        0,
        0,
        this.frameWidth,
        this.frameHeight,
      );

      if (this.frameIndex === this.numberOfFrames - 1) {
        loop.remove('sprite-animation');
        this.isLooping = false;

        this.frameIndex = this.numberOfFrames - 1;
      }
    },
  },

  beforeDestroy() {
    if (this.isLooping) loop.remove('sprite-animation');
    eventBus.$off('explode!');
  },
};
</script>

<style lang="scss" scoped>
.exploded {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/ExplodedImage.vue